module.exports = {"description":"","displayName":"Spinner","methods":[],"props":{"size":{"type":{"name":"enum","value":[{"value":"'small'","computed":false},{"value":"'big'","computed":false}]},"required":false,"description":"Size of the Spinner","defaultValue":{"value":"'small'","computed":false}},"cssMap":{"defaultValue":{"value":"require( './spinner.css' )","computed":true},"required":false}}}


//////////////////
// WEBPACK FOOTER
// ./.lochness/props/Spinner-props.json
// module id = 469
// module chunks = 0